const PageStruct = {
  id: "order-history",
  useLayout: true,
  children: [{ id: "order-history", order: 1 }],
};

export default PageStruct;
